/**
 * Rounds a quantity to a certain number of decimal places
 *
 * @param {number} quantity - The quantity to round
 * @param {number} decimals - The number of decimal places (> 0)
 * @returns {number} - The quantity rounded with the specified number of decimal places
 */
export const roundToDecimals = (quantity, decimals) => {
    const powerOfTen = 10 ** decimals;
    return Math.round(powerOfTen * quantity) / powerOfTen;
};
